import * as types from './actionTypes';

export default function itemCopied(containerId) {
  return { type: types.ITEM_COPIED, payload: { containerId } };
}
